import { getContentType } from "plos/src/utils/pulse";
import { NewsThumb } from "./NewsThumb";
import {
  newsItemBody,
  newsItemStyles,
  newsLink,
  newsTag,
  newsTitle,
} from "./newsItem.css";
import { NewsItemProps } from "./types";

/**
 * The **NewsItem** component should be used within a **NewsList** component to enable
 * container queries via the `@container` rule.
 *
 * There are three variants:
 * 1. **Default:** On larger sizes the NewsItem contents will appear stacked. Whereas
 * on smaller screen sizes the NewsItem contents will have a more horizontal layout
 * 2. **Compact:** On both larger and smaller sizes the NewsItem contents will appear stacked
 * 3. **Scrollable:** A minWidth is applied for when the items appear in a scrollable row
 */
const NewsItem = ({
  imgSizes,
  imgWidth,
  news,
  variant = "default",
}: NewsItemProps) => {
  const { tags, title } = news;

  // Find the tag label containing the label: prefix and return everything after it
  const getLabelFromTags = () => {
    const labelTag = tags.find((tag) => tag.label.includes("label:"));
    if (!labelTag) return undefined;
    const parts = labelTag.label.split(":");
    return parts.length > 1 ? parts.slice(1).join(":").trim() : undefined;
  };

  const label = getLabelFromTags();

  return (
    <a
      className={newsLink}
      href={`${import.meta.env.VITE_HF_BASE}/en/${getContentType(news.type)}/${
        news.id
      }`}
    >
      <div className={newsItemStyles}>
        <div className={newsItemBody[variant]}>
          <h3 className={newsTitle}>{title}</h3>
          <NewsThumb news={news} imgWidth={imgWidth} sizes={imgSizes} />
        </div>
        {label && <div className={newsTag}>{label}</div>}
      </div>
    </a>
  );
};

export default NewsItem;
